import React from 'react';
import PropTypes from 'prop-types';
import DefaultContext  from "./Context";
import NotificationContext  from "./NotificationContext";
import {EmitEvents,html2text} from '../../utils';
import Button from '@mui/material/Button';
class Provider extends React.PureComponent{
  constructor(props){
    super(props);
    this.state={
      notifications:0,
      notificationsList:[],
      deletedList:[],
      refreshingNoti:false,
      page:1,
      limit:10,
      // Phân loại theo công ty: null = công ty đang đăng nhập (mặc định), "_all" = tất cả,
      // "_chung" = thông báo chung không gắn công ty, còn lại là id_app của một công ty khác.
      selectedApp:null,
      companies:[],
      showNotifications:this.showNotifications.bind(this),
      loadMoreNotification:this.loadMoreNotification.bind(this),
      updateNotify:this.updateNotify.bind(this),
      openNotify:this.openNotify.bind(this),
      deleteNotify:this.deleteNotify.bind(this),
      readAll:this.readAll.bind(this),
      selectApp:this.selectApp.bind(this),
      refreshCounts:this.refreshCounts.bind(this),
    }
    // Server bắn 'notify:count' kèm số chưa đọc của công ty có thông báo vừa tới (có thể KHÔNG phải công ty
    // đang mở) -> không dùng con số đó, chỉ coi là tín hiệu để đếm lại theo công ty hiện tại.
    EmitEvents.subscribe("notify:count",()=>{
      this.refreshCountsSoon();
    })
    EmitEvents.subscribe("notify:new",async (event)=>{
      this.refreshCountsSoon();
      if(!this._listLoaded) return;
      try{
        let notification = await this.context.apis.asyncGetData(this.context.getToken(),"notification",{_id:event._id});
        if(!notification || !this.thuocBoLoc(notification)) return;
        if((this.state.notificationsList||[]).find(n=>n._id===notification._id)) return;
        this.setState({notificationsList:[notification,...this.state.notificationsList]});
      }catch(e){
        console.log("[Notification] không tải được thông báo mới",e);
      }
    })
    //
    const self = this;
    const listener =  async (e)=>{
      if(e.data && e.data!=='recaptcha-setup'){
        let data = e.data;
        if(typeof(data)=="string"){
          try{
            data = JSON.parse(data);
          }catch(e){
            console.error(e,data);
            return;
          }
        }
        if(data.notificationResponse){
          if(data.notificationResponse.notify_id){
            try{
              let notification = await self.context.apis.asyncGetData(self.context.getToken(),"notification",{_id:data.notificationResponse.notify_id});
              if(notification){
                self.openNotify(notification);
              }else{
                self.context.alert("Không tìm thấy nội dung thông báo");
              }
            }catch(e){
              self.context.alert(e.error || e.message||e);
            }
          }else{
            //self.context.alert("Thông báo: " + JSON.stringify(e.data.notificationResponse));
          }
        }
        if(data.platform){
          self.context.userInfo.platform = data.platform;
        }
      }
    }
    window.addEventListener('message',listener,false);
    document.addEventListener('message',listener,false);
  }
  componentDidMount(){
    this._currentAppId = this.currentAppId();
    this.refreshCounts();
  }
  componentDidUpdate(){
    // Đổi công ty / đăng nhập lại -> quay về bộ lọc mặc định (công ty đang đăng nhập) và đếm lại.
    const id_app = this.currentAppId();
    const email = this.context.userInfo && this.context.userInfo.email;
    if(id_app!==this._currentAppId || email!==this._currentEmail){
      this._currentAppId = id_app;
      this._currentEmail = email;
      this.setState({selectedApp:null,companies:[],notificationsList:[]},()=>{
        this.refreshCounts();
        if(this._listLoaded) this.showNotifications();
      });
    }
  }
  componentWillUnmount(){
    if(this._countTimer) clearTimeout(this._countTimer);
  }
  currentAppId(){
    return (this.context && ((this.context.appInfo && this.context.appInfo._id) || (this.context.config && this.context.config.id_app))) || null;
  }
  /** Bộ lọc đang chọn -> điều kiện exfields.id_app; undefined = không lọc. */
  dieuKienCongTy(selectedApp=this.state.selectedApp){
    if(selectedApp==="_all") return undefined;
    if(selectedApp==="_chung") return {$in:["",null]};
    if(selectedApp) return selectedApp;
    const cur = this.currentAppId();
    // Công ty đang đăng nhập: kèm cả thông báo chung (không gắn công ty) như trước đây.
    return cur ? {$in:[cur,"",null]} : undefined;
  }
  /** Thông báo có thuộc bộ lọc đang chọn không (dùng cho thông báo mới tới qua socket). */
  thuocBoLoc(noti){
    const id = (noti && noti.exfields && noti.exfields.id_app) || "";
    const sel = this.state.selectedApp;
    if(sel==="_all") return true;
    if(sel==="_chung") return !id;
    if(sel) return id===sel;
    const cur = this.currentAppId();
    return !cur || !id || id===cur;
  }
  refreshCountsSoon(){
    if(this._countTimer) clearTimeout(this._countTimer);
    this._countTimer = setTimeout(()=>this.refreshCounts(),400);
  }
  /** Đếm thông báo theo công ty; số trên chuông = chưa đọc của công ty đang đăng nhập + thông báo chung. */
  async refreshCounts(){
    if(!this.context.userInfo || !this.context.getToken || !this.context.getToken()) return;
    try{
      const url = `${this.context.config.server_url}/api/notification/count/by-app?access_token=${this.context.getToken()}`;
      let companies = await this.context.apis.asyncGet(url);
      if(typeof companies==="string") companies = JSON.parse(companies);
      if(!Array.isArray(companies)) return;
      const cur = this.currentAppId();
      const notifications = companies
        .filter(c=>!cur || !c.id_app || c.id_app===cur)
        .reduce((t,c)=>t+(c.unread||0),0);
      this.setState({companies,notifications});
    }catch(e){
      console.log("[Notification] không đếm được thông báo theo công ty",e);
    }
  }
  selectApp(selectedApp){
    if(selectedApp===this.currentAppId()) selectedApp = null;
    this.setState({selectedApp},()=>this.showNotifications(1,this.state.limitNoti||10,false));
  }
  async showNotifications(page=1,limit=10,append=false){
    if(!this.context.userInfo) return;
    this._listLoaded = true;
    if(page===1 && !append) this.refreshCounts();
    if(!append){
      this.setState({notificationsList:[],refreshingNoti:true})
    }else{
      this.setState({refreshingNoti:true})
    }
    const selectedApp = this.state.selectedApp;
    try{
      let condition = {
      }
      const dk = this.dieuKienCongTy(selectedApp);
      if(dk!==undefined){
        condition["exfields.id_app"] = dk;
      }
      let url = `${this.context.config.server_url}/api/notification?access_token=${this.context.getToken()}&page=${page}&limit=${limit}&q=${encodeURIComponent(JSON.stringify(condition))}`;
      let rs = JSON.parse(await this.context.apis.asyncGet(url));
      // Người dùng đã đổi bộ lọc trong lúc chờ -> bỏ kết quả cũ.
      if(selectedApp!==this.state.selectedApp) return;
      if(append){
        rs = [...this.state.notificationsList,...rs];
      }
      // KHÔNG tự đánh dấu đã đọc ở đây: thông báo chỉ là "đã đọc" khi người dùng mở nó ra xem (openNotify).
      this.setState({notificationsList:rs,pageNoti:page,limitNoti:limit,refreshingNoti:false});
    }catch(e){
      this.setState({refreshingNoti:false})
      console.log("Error when load notifications:",e);
    }
  }
  async loadMoreNotification(){
    await this.showNotifications((this.state.pageNoti||0)+1,(this.state.limitNoti||10),true);
  }
  async updateNotify(_id,data){
    try{
      let url = `${this.context.config.server_url}/api/notification/${_id}?access_token=${this.context.getToken()}`;
      await this.context.apis.asyncPost(url,null,data,"PUT","updateStatusNotify");
    }catch(e){
      console.log(e);
    }
  }
  /** Đánh dấu đọc tại chỗ trong danh sách đang hiển thị (không chờ server). */
  danhDauDaDocTaiCho(ids){
    const set = ids ? new Set(ids) : null;
    this.setState({notificationsList:(this.state.notificationsList||[]).map(n=>(n && !n.read && (!set || set.has(n._id)))?{...n,read:true}:n)});
  }
  async readAll(){
    try{
      this.context.setProgressStatus(true);
      // Chỉ "đọc hết" trong phạm vi đang xem (công ty đang chọn), không đụng thông báo của công ty khác.
      const sel = this.state.selectedApp;
      let qs = "";
      if(sel==="_chung") qs = "&id_app=_chung";
      else if(sel && sel!=="_all") qs = `&id_app=${sel}&only=1`;
      else if(!sel && this.currentAppId()) qs = `&id_app=${this.currentAppId()}`;
      const url = `${this.context.config.server_url}/api/notification/read/all?access_token=${this.context.getToken()}${qs}`;
      await this.context.apis.asyncGet(url);
      this.danhDauDaDocTaiCho();
      await this.refreshCounts();
      this.context.setProgressStatus(false);
      this.context.alert(this.context.apis.getLabel("Chương trình đã thực hiện xong"));
    }catch(e){
      this.context.setProgressStatus(false);
      this.context.alert(e.error||e.message ||e,null,"red");
    }
  }

  /**
   * Đường dẫn mở MỘT bản ghi bằng DataListManager nếu phân hệ `code` có khai báo trong data_list_config:
   *   /page/{list|voucher}/{moduleCode}?action=view&id=<id>   (DataListManager đọc ?action=view&id= và mở màn hình xem).
   * Không có khai báo (hoặc tra lỗi) -> null để nơi gọi giữ đường cũ của InputBase.
   *
   * Tìm theo moduleCode trước; không có thì theo apiCode — CHỈ khi đúng một cấu hình dùng apiCode đó (nhiều màn hình cùng một bảng
   * thì không đoán). Chứng từ (có số chứng từ + dòng chi tiết) đi /page/voucher/ để form mở đúng bố cục chứng từ.
   * Nhớ kết quả theo công ty trong phiên — bấm nhiều thông báo cùng loại không phải hỏi lại máy chủ.
   */
  async duongDanDataList(code,id){
    const ma = String(code||'').trim();
    const idBanGhi = String(id||'').trim();
    if(!ma || !idBanGhi) return null;
    if(!this._dlcCache) this._dlcCache = new Map();
    const khoa = (this.currentAppId() || '') + '|' + ma.toLowerCase();
    let cauHinh = this._dlcCache.get(khoa);
    if(cauHinh === undefined){
      cauHinh = null;
      try{
        const token = this.context.getToken();
        const lay = async (condition,limit)=>{
          const rs = await this.context.apis.asyncGetList(token,"data_list_config",{condition,limit,fields:"moduleCode,apiCode,fields.field,fields.type"});
          return (rs && (rs.data || rs)) || [];
        };
        const theoModule = await lay({moduleCode:ma},1);
        if(theoModule.length) cauHinh = theoModule[0];
        else{
          const theoApi = await lay({apiCode:ma},2);
          if(theoApi.length===1) cauHinh = theoApi[0];
        }
        if(cauHinh){
          const truong = Array.isArray(cauHinh.fields) ? cauHinh.fields : [];
          const laChungTu = truong.some(f=>f && f.field==='so_ct') && truong.some(f=>f && f.type==='ObjectArray');
          cauHinh = { moduleCode: cauHinh.moduleCode || ma, type: laChungTu ? 'voucher' : 'list' };
        }
      }catch(e){
        console.log("[Notification] không tra được data_list_config của",ma,e);
        return null;   // lỗi tạm thời: không nhớ, lần sau hỏi lại
      }
      this._dlcCache.set(khoa,cauHinh);
    }
    if(!cauHinh) return null;
    return `/page/${cauHinh.type}/${encodeURIComponent(cauHinh.moduleCode)}?action=view&id=${encodeURIComponent(idBanGhi)}`;
  }

  async openNotify(noti,_history){
    const history = _history || this.props.history;
    // Mở ra xem = đã đọc (đây là chỗ DUY NHẤT đánh dấu đọc từng thông báo).
    if(!noti.read){
      this.danhDauDaDocTaiCho([noti._id]);
      this.updateNotify(noti._id,{read:true}).then(()=>this.refreshCountsSoon());
    }
    // Thông báo mang ĐƯỜNG DẪN trong ứng dụng (exfields.url, vd nhắc lịch chăm sóc khách '/#/page/custom/<mã>?cua_toi=1')
    // -> mở thẳng trang đó (kể cả khi thông báo có kèm nội dung email). Chỉ nhận đường dẫn nội bộ '/#/…' hoặc '#/…'.
    const duongDan = noti && noti.exfields && typeof noti.exfields.url === 'string' ? noti.exfields.url.trim() : '';
    const khopDuongDan = /^\/?#(\/(?!\/).*)$/.exec(duongDan);
    if(khopDuongDan){
      if(noti.exfields.id_app && this.context.config.id_app && noti.exfields.id_app!==this.context.config.id_app){
        this.context.alert(`${this.context.apis.getLabel("Thông báo này từ")} ${noti.exfields.company}. ${this.context.apis.getLabel("Bạn cần đăng nhập vào công ty này để xem chi tiết.")}`)
        return;
      }
      if(history) history.push(khopDuongDan[1]);
      else window.location.hash = '#' + khopDuongDan[1];
      return;
    }
    
    // Thông báo yêu cầu duyệt: tải lại bản mới nhất trước khi mở — danh sách đang giữ có thể là bản cũ,
    // trong khi yêu cầu đã được duyệt/từ chối ở nơi khác (server sẽ ẩn 2 nút Duyệt/Từ chối, xem models/approve.js).
    if(noti && noti.exfields && noti.exfields.rq_approve && !noti.exfields.approve_processed && noti._id){
      try{
        const moi = await this.context.apis.asyncGetData(this.context.getToken(),"notification",{_id:noti._id});
        if(moi && moi.exfields){
          noti = moi;
          if(moi.exfields.approve_processed){
            this.setState({notificationsList:(this.state.notificationsList||[]).map(n=>n && n._id===moi._id?{...n,...moi}:n)});
          }
        }
      }catch(e){
        console.log("[Notification] không tải lại được thông báo duyệt",e);
      }
    }
    if(noti && noti.exfields && noti.exfields.email_content && html2text(noti.exfields.email_content).trim().split("\n").join()){
      this.context.alert(<div dangerouslySetInnerHTML={{__html:noti.exfields.email_content}}></div>);
      return;
    }
    //open voucher
    if(noti && noti.exfields && noti.exfields.code && noti.exfields._id){
      let code = (noti.exfields.code||"").toLowerCase();
      if(noti.exfields.id_app!==this.context.config.id_app){
        this.context.alert(`${this.context.apis.getLabel("Thông báo này từ")} ${noti.exfields.company}. ${this.context.apis.getLabel("Bạn cần đăng nhập vào công ty này để xem chi tiết.")}`)
        return;
      }
      
      if(history){
        this.context.alert(<div dangerouslySetInnerHTML={{__html:noti.content||noti.title}}></div>,<div style={{display:"flex",flexDirection:"row",justifyContent:"center",marginTop:10,minWidth:200}}>
          <Button variant="contained" color="primary" fullWidth onClick={async ()=>{
              if(this.openDetailNotify){
                this.openDetailNotify(code,noti,history);
              }else{
                switch(code) {
                  case "task":{
                    history.push('/task/' + noti.exfields._id);
                    break;
                  }
                  case "message2":{
                    let msg = await this.context.apis.asyncGetData(this.context.getToken(),"message2",{_id:noti.exfields._id});
                    if(msg){
                      if(msg.code_link==="okr"){
                        return history.push("/okr/" + msg.id_link +"?tab=2");
                      }
                      if(msg.code_link==="strategicplan"){
                        return history.push("/strategicplan/" + msg.id_link +"?tab=4");
                      }
                      if(msg.code_link==="strategicgoal"){
                        return history.push("/strategicgoal/" + msg.id_link +"?tab=3");
                      }
                      if(msg.code_link==="strategicobjective"){
                        return history.push("/strategicobjective/" + msg.id_link +"?tab=2");
                      }
                      if(msg.code_link==="strategickpi"){
                        return history.push("/strategickpi/" + msg.id_link +"?tab=3");
                      }
                      if(msg.code_link==="keyresult"){
                        return history.push("/keyresult/" + msg.id_link +"?tab=3");
                      }
                      if(msg.code_link==="task"){
                        return history.push("/task/" + msg.id_link +"?tab=2");
                      }
                      if(msg.id_link){
                        this.context.chat({id_link:msg.id_link});
                      }else{
                        history.push("/chat");
                      }
                    }else{
                      this.context.alert(`${this.context.apis.getLabel("Tin nhắn này đã bị xoá")}`)
                    }
                    break;
                  }
                  case "calllog":{
                    history.push('/list/' + code.toLowerCase() + '?phone=' + noti.exfields.phone);
                    break;
                  }
                  
                  default:{
                    console.log("[Nofitication] xem chi tiết:",noti,this.context.queryParams.for_agent);
                    // ƯU TIÊN DataListManager: phân hệ có khai báo trong data_list_config thì mở trang mới
                    // /page/{list|voucher}/{code}?action=view&id=<_id> (DataListManager mở thẳng màn hình xem bản ghi);
                    // không có khai báo thì giữ đường cũ (InputBase): /view/{code}/{id} hoặc /list/{code}?_id=<_id>.
                    if(noti.exfields.id_link && noti.exfields.code_link && !this.context.queryParams.for_agent){
                      const codeLink = String(noti.exfields.code_link).toLowerCase();
                      const moi = await this.duongDanDataList(codeLink,noti.exfields.id_link);
                      history.push(moi || `/view/${codeLink}/${noti.exfields.id_link}`);
                    }else{
                      const moi = await this.duongDanDataList(code,noti.exfields._id);
                      history.push(moi || ('/list/' + code.toLowerCase() + '?_id=' + noti.exfields._id));
                    }
                    break;
                  }
                }
              }
            }}>
              {this.context.apis.getLabel("Chi tiết")}
          </Button>
          <Button variant="contained" fullWidth style={{marginLeft:5}}>{this.context.apis.getLabel("Đóng")}</Button>
        </div>)
        return;
      }else{
        this.context.alert(<div dangerouslySetInnerHTML={{__html:"<div>" + (noti.content||noti.title) + "</div>"}}></div>);
      }
    }
  }
  deleteNotify(_id){
    try{
      this.context.alert(this.context.apis.getLabel("Bạn muốn xoá thông báo này?"),async (y)=>{
        if(y){
          let url = `${this.context.config.server_url}/api/notification/${_id}?access_token=${this.context.getToken()}`;
          await this.context.apis.asyncDelete(url);
          let notificationsList = this.state.notificationsList.filter(n=>n._id!==_id);
          let deletedList = (this.state.deletedList||[]);
          deletedList.push(_id);
          this.setState({notificationsList,deletedList})
          this.refreshCountsSoon();
        }
      })
    }catch(e){
      console.log(e);
    }
  }
  render(){
    return (
      <NotificationContext.Provider value={this.state}>
        {this.props.children}
      </NotificationContext.Provider>
    )
  }
}
Provider.contextType = DefaultContext;
Provider.propTypes={
  children: PropTypes.any,
  history:PropTypes.any,
  location:PropTypes.any,
}
export default Provider;
